module.exports = __webpack_public_path__ + "static/media/info_wave_1.2ac826d8.jpg";